<template>
  <div>
    <b-modal id="professionsFilterModal" size="lg" title="Фильтр профессий" @ok="onSave" @show="updateData">
      <b-button variant="outline-primary" class="mb-2 btn-sm" @click="clearFilters">Сбросить фильтр</b-button>
      <b-form-group label="Город">
        <MultiSelect v-model="filters.cities" :multiple="true" :options="cities"></MultiSelect>
      </b-form-group>
      <b-form-group label="Дочернее общество">
        <MultiSelect v-model="filters.subdivisions" :multiple="true" :options="subdivisions" label="title" trackBy="id">
        </MultiSelect>
      </b-form-group>
      <b-form-group label="Требуемый пол">
        <RawMultiselect v-model="filters.gender" :options="genders" track-by="value" label="text" :searchable="false"
          select-label="Нажмите enter, чтобы выбрать" deselect-label="Нажмите enter, чтобы удалить"
          placeholder="Выберите вариант">
        </RawMultiselect>
      </b-form-group>
      <b-form-group label="Требуемое гражданство">
        <RawMultiselect v-model="filters.citizenship" :options="countries" track-by="value" label="text"
          :searchable="false" select-label="Нажмите enter, чтобы выбрать" deselect-label="Нажмите enter, чтобы удалить"
          placeholder="Выберите вариант">
        </RawMultiselect>
      </b-form-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="onSave" variant="primary">
          Найти
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import RecommendationAPI from '@/api/recommendation'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import RawMultiselect from 'vue-multiselect'
import COUNTRIES from "@/components/helpers/countries-to-select.json"

export default {
  name: 'EditProfessionModal',
  components: {
    AgGridVue,
    MultiSelect,
    RawMultiselect
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      }
    }
  },
  props: {
    editData: {
      type: Object,
      default() {
        return {}
      }
    },
    professionsList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      filters: {
        cities: [],
        subdivisions: [],
        words: '',
        gender: null,
        citizenship: null
      },
      cities: [],
      subdivisions: [],
      genders: [
        { value: null, text: 'Не имеет значения' },
        { value: 'm', text: 'М' },
        { value: 'f', text: 'Ж' },
      ],
      countries: []
    }
  },
  computed: {
  },
  async created() {
    const professions = (await RecommendationAPI.getProfessionsList()).data.professions;
    await this.getCities(professions)
    await this.getSubdivisions();
    const allProfessionsCountries = _.union.apply(null, professions.map(d => d.citizenship));
    this.countries = allProfessionsCountries.map((d) => ({ value: d, text: COUNTRIES.find((r) => r.value === d).text }))
  },
  methods: {
    updateData() {
      this.filters = this.editData
    },
    getCities(data) {
      const organizations = (_.uniqBy(data, 'organization.city'));
      for (const org of organizations) {
        if (org.organization.city)
          this.cities.push(org.organization.city)
      }
      this.cities.sort();
    },
    async getSubdivisions() {
      for (const profession of this.professionsList) {
        this.subdivisions.push(profession.organization);
      }
      this.subdivisions = _.uniqBy(this.subdivisions, 'id');
    },
    onSave() {
      this.$emit('onSearchClick')
      this.$bvModal.hide('professionsFilterModal')
    },
    clearFilters() {
      this.filters.cities = [];
      this.filters.subdivisions = [];
      this.filters.words = '';
      this.filters.gender = null;
      this.filters.citizenship = null;
    }
  }
}
</script>

<style scoped>
.ag-grid-olympics-list {
  height: calc(100vh - 600px);
  min-height: 250px;
}
</style>
